//
//
//
//
//
//
//
//
//
//
//
//

import Footer from './components/Footer.vue'
import NowPlaying from './components/NowPlaying.vue'

export default {
  name: 'LayoutDefault',

  components: {
    Footer,
    NowPlaying
  },

  data () {
    return {
    }
  }
}
